var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaperIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m5 4.667-.039.002a.334.334 0 0 0-.292.292L4.667 5v2H1.333A.33.33 0 0 1 1 6.669V1.33C1 1.148 1.148 1 1.331 1H6.67c.183 0 .331.15.331.333v3.334zm2 .666L5.333 7V5.333z"
})));
export { SvgPaperIcon as ReactComponent };
export default __webpack_public_path__ + "c4ff6e770e5cf0e469b02af5757e0d1e.svg";